/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  
  // on off jquery
  $('.centi').hide();
  $('.onoffbtn').on('click', function(){
  if($(this).children().is(':checked')){
    $(this).addClass('active');
    $('.centi').show();
    $('.inches').hide();
  }
  else{
    $(this).removeClass('active')
     $('.centi').hide();
     $('.inches').show();
  }
});

  
  // 1st carousel, main
$('.Product__Slideshow').flickity();
// 2nd carousel, navigation
$('.Product__SlideshowNavScroller').flickity({
  asNavFor: '.Product__Slideshow',
  contain: true,
  pageDots: false,
 // wrapAround: true,
  cellAlign: 'left'
});
  });

